<app-message
  [message]="message"
  [subMessage]="subMessage"
  [icon]="icon"
>
</app-message>
